module.exports = __webpack_public_path__ + "web/img/chapter-30.9eafe2db.png";